<!-- Single row: title joins the row -->
<div *ngIf="cardData.rows.length === 1" class="recurring-payment-card d-flex align-items-center gap-4">
  <div class="d-flex flex-column flex-grow-1 gap-1">
    <div class="card-title" i18n>{{ cardTitle }}</div>
    <div *ngIf="cardData.rows[0].cardText" class="detail-label" i18n>{{ cardData.rows[0].cardText }}</div>
  </div>
  <div class="d-flex flex-column align-items-end gap-1">
    <div [class]="cardData.rows[0].useMinimumAmount !== null ? 'detail-value' : 'detail-value-muted'" i18n>
      {{ cardData.rows[0].paymentAmount | currency }} {{ frequencyLabel }}
    </div>
    <div *ngIf="cardData.rows[0].useMinimumAmount !== null" class="detail-sub-value" i18n>
      {{ cardData.rows[0].useMinimumAmount ? 'Minimum' : 'Custom' }}
    </div>
  </div>
</div>

<!-- Multi-row: title on top, rows below -->
<div *ngIf="cardData.rows.length > 1" class="recurring-payment-card d-flex flex-column gap-2">
  <div class="card-title" i18n>{{ cardTitle }}</div>
  <div class="d-flex flex-column gap-2">
    <ng-container *ngFor="let row of cardData.rows; let last = last">
      <app-vb-payments-recurring-payment-row [row]="row" [frequencyLabel]="frequencyLabel" />
      <hr *ngIf="!last" class="m-0" />
    </ng-container>
  </div>
</div>
